
import y from "../../../../public/projects/shubh/projects/y.jpg";
import s from "../../../../public/developers/images/logo/shubh.png";
import evergreen from "../../../../public/projects/shubh/projects/ev.jpg"

// nirvana
import overviewImagenirvana from "../../../../public/projects/shubh/nirvana/overview/1.webp";
import bannerDesktopImagenirvana from "../../../../public/projects/shubh/nirvana/banner/1.webp";
import bannerDeveloperImagenirvana from "../../../../public/projects/shubh/nirvana/banner/3.webp";
import bannerMobileImagenirvana from "../../../../public/projects/shubh/nirvana/banner/2.webp";
import Locationnirvana from "../../../../public/projects/shubh/nirvana/location/1.webp";
import Hightlightsnirvana from "../../../../public/projects/shubh/nirvana/highlights/1.webp";
import floorplan1nirvana from "../../../../public/projects/shubh/nirvana/floorplan/1.webp";
import floorplan2nirvana from "../../../../public/projects/shubh/nirvana/floorplan/2.webp";
import floorplan3nirvana from "../../../../public/projects/shubh/nirvana/floorplan/3.webp";
import floorplan4nirvana from "../../../../public/projects/shubh/nirvana/floorplan/4.webp";
import floorplan5nirvana from "../../../../public/projects/shubh/nirvana/floorplan/5.webp";
import locationiconnirvana from "../../../../public/projects/shubh/nirvana/overview/l.png";
import caliconnirvana from "../../../../public/projects/shubh/nirvana/overview/c.png";
import newlaunchiconnirvana from "../../../../public/projects/shubh/nirvana/overview/n.png";
import gallery1nirvana from "../../../../public/projects/shubh/nirvana/gallery/1.webp";
import gallery2nirvana from "../../../../public/projects/shubh/nirvana/gallery/2.webp";
import gallery3nirvana from "../../../../public/projects/shubh/nirvana/gallery/3.webp";
import gallery4nirvana from "../../../../public/projects/shubh/nirvana/gallery/4.webp";
import gallery5nirvana from "../../../../public/projects/shubh/nirvana/gallery/5.webp";



export const developershubh = {
  properties: [
    {
      name: "Shubh Nirvana",
      image: bannerDeveloperImagenirvana,
      price: "1.57 Crore Onwards",
      state: "Pune",
      developer: "shubh",
      location: "Viman Nagar, Pune",
      projectlocation: "Pune",
      bed: "3 & 4 BHK Apartments",
      size: "1129-2433 sq.ft.",
      url: `/shubh-nirvana`,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "shubh Nirvana",
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
  ],
};
export const Headers = {
  logo: s,
  data: {
    experience: "2006",
  },
  about: `Shubh Developer, based in Pune, is a premier real estate development company committed to delivering high-quality residential and commercial projects. Since its inception in 2006, Shubh has established a reputation for excellence, innovation, and integrity in the Pune real estate market.`,
};

export const projectsshubh = {
  nirvana: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImagenirvana,
      bannerMobileImage: bannerMobileImagenirvana,
      textOverlay: "",
      data: {
        title: "Shubh Nirvana",
        subtitle: "Viman Nagar, Pune",
        starting_price: "₹ 1.5 Cr Onwards",
        payment_plan: "Under Construction",
        rerano: "P52100031263",
        status: "Under Construction",
      },
    },
    overview: {
      heading: "Premium Living in Viman Nagar, Pune",
      description: [
        "Shubh Nirvana is a premium residential project in Viman Nagar, Pune, developed by Shubh Developers. Spanning approximately 7 acres, the project comprises 7 towers with 14 storeys each, offering over 450 units.",
        "The residences include 3 BHK and 4 BHK configurations, with carpet areas ranging from 1,329 to 2,433 sq.ft. Strategically located near Pune International Airport, Shubh Nirvana offers excellent connectivity to key areas like Kalyani Nagar, Koregaon Park, and the upcoming Ramwadi Metro Station.",
      ],
      keywordLinks: {},
      image: overviewImagenirvana,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconnirvana,
          title: "₹ 1.5 Cr Onwards",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconnirvana,
          title: "Under Construction",
          subtitle: "Status",
        },
        {
          iconClass: newlaunchiconnirvana,
          title: "Viman Nagar",
          subtitle: "Location",
        },
      ],
    },
    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK",
          area: "1129 - 1332 sq. ft.",
          price: "₹ 1.57 - 2.18 Cr Onwards",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK",
          area: "1611 - 2433 sq. ft.",
          price: "₹ 2.25 - 3.9 Cr Onwards",
          eoiAmount: "On Request",
        },
      ],
    },
    floor_plan: [
      {
        type: "3 BHK",
        area: "1129 - 1332 sq. ft.",
        price: "₹ 1.57 - 2.18 Cr Onwards",
        image: floorplan1nirvana,
      },
      {
        type: "4 BHK",
        area: "1611 - 2433 sq. ft.",
        price: "₹ 2.25 - 3.9 Cr Onwards",
        image: floorplan2nirvana,
      },
    ],
    highlights: {
      images: Hightlightsnirvana,
      tagline: "Highlights",
      features: [
        "Just a minute away from Airport",
        "Ample amenities space on one acre",
        "Elegantly designed",
        "An extravagance-inspired design",
        "A luxury interior specification",
        "13 towers with 310 units",
        "Expected possession by December 2025",
      ],
    },
    location: {
      image: Locationnirvana,
      data: [
        {
          airport: {
            distance_time: "350 Meters",
            name: "Pune International Airport",
          },
          school: {
            distance_time: "70 Meters",
            name: "Symbiosis School of International Studies",
          },
          railwayormetro: {
            distance_time: "2.5 Km",
            name: "Ramwadi Metro Station",
          },
          hospital: {
            distance_time: "3.8 Km",
            name: "Sahyadri Super Speciality Hospital",
          },
          mall: {
            distance_time: "2.2 Km",
            name: "Hyatt Regency Pune",
          },
        }
      ]
    },
    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1nirvana },
        { image: gallery2nirvana },
        { image: gallery3nirvana },
        { image: gallery4nirvana },
        { image: gallery5nirvana },
      ],
    },
    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "",
      welcomeMessage:
      "Hi! I'm interested in Shubh Nirvana, kindly share more details.",
    },
    faq: [
      {
        question: "What is the possession date?",
        answer: "The possession for Shubh Nirvana is scheduled for December 2025.",
      },
      {
        question: "Is the project RERA registered?",
        answer: "Yes, Shubh Nirvana is RERA registered with the ID P52100031263.",
      },
      {
        question: "What amenities are provided?",
        answer: "Amenities include a clubhouse, swimming pool, gymnasium, yoga and meditation zones.",
      },
      {
        question: "How many towers and units are there?",
        answer: "The project comprises 13 towers with a total of 310 units spread over 7 acres.",
      },
      {
        question: "What is the price range of the apartments?",
        answer: "Prices range from ₹1.5 crore for 3 BHK units to ₹3 crore for 4 BHK units.",
      },
      {
        question: "Are there any eco-friendly features?",
        answer: "Yes, the project includes features like rainwater harvesting and energy-efficient lighting.",
      },
      {
        question: "Is there parking available?",
        answer: "Yes, the project offers covered parking spaces for residents.",
      },
      {
        question: "What is the status of construction?",
        answer: "Shubh Nirvana is currently under construction, with possession expected by December 2025.",
      },
      {
        question: "Who is the developer?",
        answer: "Shubh Nirvana is developed by Shubh Developers.",
      },
      {
        question: "Where is Shubh Nirvana located?",
        answer: "The project is located in Survey No. 227, Plot No. 4, opposite Symbiosis Law School, Mhada Colony, Viman Nagar, Pune.",
      },
    ],
    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry",
      to_email: "leads@gurugram-property.com",
    },
  },
};